const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

const routes = {
  cart_add_url: '/cart/add',
  cart_url: '/cart',
  cart_change_url: '/cart/change',
  cart_clear_url: '/cart/clear',
  search_url: '/search',
  predictive_search_url: '/search/suggest',
};